module.exports = __webpack_public_path__ + "img/img2.a1dac1c8.jpg";